import axios from "./axios-wrapper";

export const getReporting = async (payload) => {
    const response = await axios.post("/history/reporting", {
        ...payload,
        from_timestamp: payload.from.unix(),
        to_timestamp: payload.to.unix(),
    });
    return response.data;
}